import React, {useState} from 'react'
import styled from 'styled-components';
import NoticeModel from './NoticeModel'

const ContentStyle = styled.div`
  h2 {
    color: #333333;
    margin: 30px 0;
  }
  .desc {
    color: #7D8A96;
    font-size: 15px;
    line-height: 26px;
    padding-bottom: 40px;
    border-bottom: 1px solid #AEB7C1;
    .item {
      margin-bottom: 20px;
    }
    >.number {
      list-style: decimal;
      padding-left: 20px;
      li {

      }
    }
  }
  h3 {
    color: #142A3F;
    margin-bottom: 20px;
  }
  .list-piece {
    line-height: 24px;
    font-size: 16px;
    color: #7D8A96;
    list-style: decimal;
    margin-bottom: 40px;
    >li {
      margin-left: 20px;
      margin-bottom: 10px;
    }
    .sub-list {
      padding-left: 15px;
      list-style: decimal;
    }
  }
  .md-40 {
    margin-bottom: 40px;
  }
  .flex-j {
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    h2 {
      margin: 20px 0;
    }
  }
`;

const W66 = styled.div`
  width: 66.6%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const W33 = styled.div`
  width: 33.3%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default function Content(props) {

  const [noticeModel, setNoticeModel] = useState(false);
  const hideNoticeModel = ()=> {
    setNoticeModel(false);
  }
  const showNoticeModel = (e)=> {
    e.preventDefault();
    setNoticeModel(true);
  }

  return (
    <ContentStyle>
      <NoticeModel
        show={noticeModel}
        onHide={hideNoticeModel}
        toSupportModel={props.toSupportModel}
      ></NoticeModel>
      
      <div className="flex-j">
        <W66>
          <h2 className="h2">Trias Anti-fraud Volunteer Alliance</h2>
          <div className="desc">
            <p className="item">Recently, several Trias-related frauds occurred in telegram, and some users were cheated of 2300 Trias tokens. Trias team attaches great importance to this. We not only publish “<a href="https://medium.com/triaslab/trias-anti-fraud-guidance-6a037fa0b85b" rel="noreferrer" target="_blank">Trias Anti-fraud Guard</a>", but also plan to organize a team called "<strong>Trias Anti-fraud Volunteer Alliance</strong>" to identify various fraud information to remind you to guard against fraud.</p>
            <p className="item">Trias will take out 1000 TRIAS as the original bonus pool to support the "<strong>Trias Anti-fraud Volunteer Alliance</strong>". On this basis, for each additional volunteer, Trias will put 10 more Trias tokens into the bonus pool. Each volunteer can submit relevant information to Trias team after discovering fraud information and timely reminding community members. After passing the audit, they will be rewarded with 1-5 Trias tokens.</p>
            <p className="item">"<strong>Trias Anti-fraud Volunteer Alliance</strong>" is a group for Trias users. Each volunteer who joins the Alliance needs to stake 10 TRIAS tokens to officially join the Alliance. </p>
            <ul className="item">
              <div>There are three purposes for staking 10 TRIAS Tokens:</div>
              <li>1) to ensure that the applicant is a Trias user; </li>
              <li>2) to prevent too many bounty hunters from participating; </li>
              <li>3) to prevent potential false and malicious intention. </li>
            </ul>
            <p className="item">The staked 10 TRIAS tokens will be returned when withdrawing from the Alliance.</p>
            <h3 className="h3">Convention of "Trias Anti-fraud Volunteer Alliance"</h3>
            <ul className="number">
              <li className="item">Once join, you should stay in the Alliance and make contributions for at least 6 month. </li>
              <li className="item">The purpose of the Alliance is anti-fraud. Any fraud occurring, members of the Alliance should immediately remind the community users of the fraud information and call on the community to report it together.</li>
              <li className="item">Anyone who swindles the bonus by deliberately making a fake will be expelled from the  Alliance once found, and the staked TRIAS token will be deducted as a fine.</li>
              <li className="item">Volunteers should supervise and help each other to promote coordination and cooperation within the Alliance.</li>
              <li className="item">Rewards will be settled on a monthly basis.</li>
            </ul>
          </div>
          
        </W66>
        <W33>
          {props.children}
        </W33>
      </div>
      <W66>
        <h2 className="h2">Grant Details:</h2>
        <ul className="list-piece">
          <li>Volunteers: TRIAS token holders and Trias community users</li>
          <li>Application time: from June 4</li>
          <li>Type of staking token: TRIAS</li>
          <li>Type of wallet available for staking: MetaMask Wallet</li>
        </ul>
      </W66>
      <W66>
        <h2 className="h2">Grant Guideline:</h2>
        <ul className="list-piece md-40">
          <li>Open Trias Grant page (<a href="https://grant.trias.one/" rel="noreferrer" target="_blank">https://grant.trias.one/#/</a>)</li>
          <li>Connect wallet and stake TRIAS token.</li>
          <li>Fill in the required information in the <a href="#" onClick={showNoticeModel}>information form.</a></li>
          <li>Trias team will contact each volunteer after the application.</li>
          <li>Change the exclusive profile picture of "<strong>Trias Anti-fraud Volunteer Alliance</strong>" and get the tag of "TAVA" in Trias community.</li>
          <li>Exercise the rights and obligations of volunteers.</li>
        </ul>

      </W66>
    </ContentStyle>
  )
}
